/**
 * Bridges the theme's custom Favoriler header cards to Magic Wishlist.
 *
 * Desktop shows `.ce-header__utility-card--wishlist` in the utilities bar while
 * Magic Wishlist's header app block lives in `.ce-header__icons`, which is hidden
 * on desktop. Clicks on the custom card open the app block's control instead.
 */
(function () {
  const TRIGGER_SELECTOR = '[data-magic-wishlist-header-trigger]';
  const APP_HEADER_BLOCK_SELECTOR = '[id*="magic_wishlist_wishlist_header_button"]';

  function findMagicWishlistControl() {
    const appBlock = document.querySelector(APP_HEADER_BLOCK_SELECTOR);
    if (!appBlock) return null;

    return (
      appBlock.querySelector('button:not([disabled])') ||
      appBlock.querySelector('a[href]') ||
      appBlock.querySelector('[role="button"]')
    );
  }

  function openMagicWishlist(event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();

    const appControl = findMagicWishlistControl();
    if (appControl) {
      appControl.click();
    }
  }

  document.addEventListener('click', openMagicWishlist);
})();
